import React from 'react';
import { Link } from 'react-router-dom';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';

const useStyles = makeStyles(theme => ({

    root: {
        height: '40%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    icon: {
        fontSize: '12rem !important',
        marginBottom: theme.spacing(6),
        color: theme.palette.secondary.light,
    },
    message: {
        marginTop: theme.spacing(2)
    }

}))

export const FingotiNotFound = ({
    homeRoute = "/"
}) => {

    const classes = useStyles();

    return (
        <Box display='flex' height='80vh' alignItems='center' justifyContent='center'>
            <Box display='flex' flexDirection='column' alignItems='center'>
                <HelpOutlineOutlinedIcon className={classes.icon} />
                <Typography variant='h3'>Page not found</Typography>
                <Typography className={classes.message}>We couldn't find that page, please <Link to={homeRoute}>go home</Link></Typography>
            </Box>
        </Box>
    );

}